import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import { AuthContext } from "../context/AuthContext";
import { getUiIcon } from "../utils/uiIcons";
import { decorateUiItems } from "../utils/uiConfig";
import { isAdminUser } from "../utils/roleUtils";
import GlobalSearch from "./GlobalSearch";
import "./Header.css";

function initialsFrom(name, email) {
  if (name && typeof name === "string") {
    const parts = name.trim().split(/\s+/);
    return (parts[0]?.[0] || "").concat(parts[1]?.[0] || "").toUpperCase();
  }

  return (email?.[0] || "?").toUpperCase();
}

function Header({ onMenuToggle, collapsed }) {
  const { user, uiConfig, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const isAdmin = isAdminUser(user);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const headerActions = useMemo(
    () => decorateUiItems(uiConfig?.headerActions || [], { isAdmin }),
    [isAdmin, uiConfig]
  );

  if (!user) return null;

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const initials = initialsFrom(user?.name, user?.email);

  return (
    <header
      className={`app-header ${scrolled ? "is-scrolled" : ""} ${
        collapsed ? "sidebar-collapsed" : ""
      }`}
    >
      <div className="header-inner">
        {onMenuToggle && (
          <button className="header-hamburger" onClick={onMenuToggle} aria-label="Toggle menu">
            <FiMenu />
          </button>
        )}

        <div className="header-left">
          <Link to="/" className="brand">
            <img src="/assets/Logo.jpg" alt="Heel logo" className="logo" />
            <span className="app-title">The Heel Portal</span>
          </Link>
        </div>

        <nav className="header-nav">
          <div className="header-search-container">
            <GlobalSearch />
          </div>
        </nav>

        <div className="header-right">
          {headerActions.map((action) => {
            const ActionIcon = getUiIcon(action.icon);
            return (
              <button
                key={action.id}
                className="btn-dashboard"
                onClick={() => navigate(action.route)}
              >
                <ActionIcon className="pulse-icon" />
                {action.label}
              </button>
            );
          })}

          <div className="user-pill" title={user?.name || user?.email}>
            <div className="avatar">{initials}</div>
            <span className="user-name">{user?.name || user?.email}</span>
          </div>
          <button className="btn-logout" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
